angular.module('v3sWbtPlayerApp').factory('v3sChangeCheckerService', ["$interval", function ($interval) {

    var v3sChangeChecker = function (objects) {
        this.objects = objects;
        this.saveCallback = null;
        this.successCallback = null;
        this.errorCallback = null;
        this.interval = null;
        this.lastSaved = true;
        this.timeInterval = 0;
        this.forcedChange = false;
        this.lastSavedTime = (new Date()).getTime();

    };

    v3sChangeChecker.prototype.setForcedChange = function () {
        this.forcedChange = true;
    };

    v3sChangeChecker.prototype.getChangeCount = function () {
        var count = this.forcedChange ? 1000 : 0;

        angular.forEach(this.objects, function (obj) {
            if (obj && obj.getChangeCount) {
                count += obj.getChangeCount();
            }
        });

        return count;
    };

    v3sChangeChecker.prototype.saveChanges = function () {
        var changesCount = this.getChangeCount();
        var timeDifference = this.geTimeSinceLastSave();

        if (this.forcedChange // Speichern vor dem Verlassen des WBTs
            || timeDifference >= 600000 // Speichern nach 10 Minuten (Keepalive)
            // SCO-Änderung => sofort speichern, sonst abhängig von der Anzahl der Seitenänderungen (1 Seite nach 90s, 2 Seiten nach 80s, ..., 9 Seiten nach 10s speichern)
            || (changesCount >= 1 && timeDifference >= this.timeInterval * (100 - changesCount * 10))) {

            this.lastSaved = this.saveCallback(changesCount);

            if (this.lastSaved) {
                this.resetChangeCount();
                this.resetInterval();
            }
        }
        
    };

    v3sChangeChecker.prototype.isLastSaved = function () {
        return this.lastSaved;
    };

    v3sChangeChecker.prototype.geTimeSinceLastSave = function () {
        return (new Date()).getTime() - this.lastSavedTime;
    };

    v3sChangeChecker.prototype.resetChangeCount = function () {
        this.lastSavedTime = (new Date()).getTime();
        angular.forEach(this.objects, function (obj) {
            if (obj && obj.resetChangeCount) {
                obj.resetChangeCount();
            }
        });
        this.forcedChange = false;
    };

    v3sChangeChecker.prototype.start = function (saveCallback, timeInterval) {
        this.saveCallback = saveCallback || function () { return true; };
        this.timeInterval = timeInterval || 1000;
        this.resetInterval();
    };

    v3sChangeChecker.prototype.resetInterval = function () {
        this.stop();
        var self = this;
        this.interval = $interval(function () { self.saveChanges(); }, self.timeInterval);
    };

    v3sChangeChecker.prototype.stop = function () {
        if (!!this.interval) {
            $interval.cancel(this.interval);
            this.interval = null;
        }
    };

    return v3sChangeChecker;

}]);